import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Magnetic } from '@/components/magnetic'

export function PillCTA({ to, children, big = false }: { to: string; children: ReactNode; big?: boolean }) {
  return (
    <Magnetic strength={0.3}>
      <Link
        to={to}
        data-cursor="link"
        className={
          big
            ? 'inline-flex min-h-16 items-center justify-center rounded-full bg-flow px-12 text-lead font-medium text-n-100 transition-colors hover:bg-flow-hi'
            : 'inline-flex min-h-14 items-center justify-center rounded-full bg-flow px-9 text-body font-medium text-n-100 transition-colors hover:bg-flow-hi'
        }
      >
        {children}
      </Link>
    </Magnetic>
  )
}
